<button
  mat-icon-button
  (click)="onCreateSku(); $event.stopPropagation()"
  matTooltip="Create New Sku"
>
  <mat-icon>add_box</mat-icon>
</button>
<button
  mat-icon-button
  (click)="onCreateVariantSku(); $event.stopPropagation()"
  matTooltip="Add as Variant"
>
  <mat-icon>library_add</mat-icon>
</button>
<ng-container *ngIf="params?.data?.rfq">
  <ng-container *ngIf="params?.data?.existingAlternateSku; else emptyAlternateSku">
    <button
      matTooltip="Already added as Alternate SKU"
      mat-icon-button
      class="alternate-sku-button__disabled"
    >
      <mat-icon>label</mat-icon>
    </button>
  </ng-container>
  <ng-template #emptyAlternateSku>
    <button
      *ngIf="params?.data?.rfq"
      mat-icon-button
      (click)="onAddAlternateSku(); $event.stopPropagation()"
      matTooltip="Add as Alternate SKU"
    >
      <mat-icon>label_outline</mat-icon>
    </button>
  </ng-template>
</ng-container>
